import styled from 'styled-components';

interface LiveStreamingVideoContainerBoxProps {
    videoIsLoading: boolean;
    videoWatchTimeLimitReached: boolean;
    displayVideo: boolean;
}

export const VideoContainerDefaultBox = styled.div<LiveStreamingVideoContainerBoxProps>`
    display: ${props => props.displayVideo ? 'block' : 'none'};
    width: 100%;
    height: 100%;
    ${props => (props.videoIsLoading || props.videoWatchTimeLimitReached) ? 'filter: blur(2px)' : null};
`;
